// import {
//   Dialog,
//   DialogActions,
//   DialogContent,
//   DialogTitle,
//   Button,
// } from "@mui/material";
// import { useEffect, useState } from "react";

// const initialForm = {
//   code: "",
//   name: "",
//   earningCategory: "F",
//   type: "E",
//   paymentType: "M",
//   defaultAmount: 0,
//   defaultPercentage: 0,
//   taxable: true,
//   isEpf: false,
//   isEtf: false,
//   isOT: false,
//   isPayee: false,
//   isNoPay: false,
//   calculationMethod: "F",
//   remarks: "",
// };

// const earningCategories = [
//   { value: "", label: "None" },
//   { value: "F", label: "Fixed" },
//   { value: "V", label: "Variable" },
// ]

// const componentTypes = [
//   { value: "E", label: "Allowance" },
//   { value: "D", label: "Deduction" },
//   { value: "C", label: "Contribution" },
// ];

// const calculationMethods = [
//   { value: "F", label: "Fixed" },
//   { value: "P", label: "Daily-Based" },
// ];

// const paymentTypes = [
//   { value: "M", label: "Monthly" },
//   { value: "W", label: "Weekly" },
// ];

// const inputClass = `
//   w-full h-14
//   rounded-md
//   border border-surface-200
//   bg-white
//   px-3.5
//   text-[16px] text-surface-800
//   outline-none
//   transition-colors
//   focus:border-primary-500
//   focus:ring-1 focus:ring-primary-500
//   disabled:bg-gray-100 disabled:text-gray-700 disabled:cursor-not-allowed
// `;

// const errorClass = '!border-red-400 focus:!border-red-500 focus:!ring-red-500';

// const labelClass = `
//   absolute
//   left-3
//   top-0
//   -translate-y-1/2
//   bg-white
//   px-1.5
//   text-[13px]
//   text-surface-500
//   pointer-events-none
//   z-10
// `;

// const maskCurrencyInput = (rawValue) => {
//   const digits = String(rawValue ?? "").replace(/\D/g, "");
//   if (!digits) return "";
//   const padded = digits.padStart(3, "0");
//   const cents = padded.slice(-2);
//   const wholeDigits = padded.slice(0, -2).replace(/^0+(?=\d)/, "");
//   const whole = Number(wholeDigits || "0").toLocaleString("en-US");
//   return `${whole}.${cents}`;
// };

// const parseCurrency = (value) => {
//   if (value === "" || value === null || value === undefined) return 0;
//   const n = Number(String(value).replace(/,/g, ""));
//   return Number.isNaN(n) ? 0 : n;
// };

// const getComponentPrefix = (earningCategory = "F", type = "E") => {
//   const catPrefix = earningCategory === "V" ? "V" : earningCategory === "F" ? "F" : "";
//   const typeMap = {
//     E: "A",
//     D: "D",
//     C: "C"
//   }
//   const typePrefix = typeMap[type] || "A";
//   return `${catPrefix}${typePrefix}`
// }

// const getNextComponentcode = (existingComponents = [], earningCategory = "F", type = "E") => {
//   const prefix = getComponentPrefix(earningCategory, type);
//   const regex = new RegExp(`^${prefix}(\\d+)$`, "i");

//   let maxNum = 0;
//   existingComponents.forEach((c) => {
//     const code = String(c.code || "").trim();
//     const match = code.match(regex);
//     if (match) {
//       const num = parseInt(match[1], 10);
//       if (!isNaN(num) && num > maxNum) {
//         maxNum = num;
//       }
//     }
//   });

//   const nextNum = String(maxNum + 1).padStart(3, "0");
//   return `${prefix}${nextNum}`;
// }

// function Field({ label, children, error = "" }) {
//   return (
//     <div className="relative">
//       <label className={labelClass}>{label}</label>
//       {children}
//       {error && (
//         <p className="mt-1.5 flex items-start gap-1 text-xs text-red-600">
//           {error}
//         </p>
//       )}
//     </div>
//   );
// }

// function TextInput({
//   label,
//   value,
//   onChange,
//   type = "text",
//   min,
//   step,
//   disabled = false,
//   error = "",
// }) {
//   return (
//     <Field label={label} error={error}>
//       <input
//         type={type}
//         value={value}
//         onChange={onChange}
//         min={min}
//         step={step}
//         disabled={disabled}
//         className={`${inputClass} ${error ? errorClass : ""}`}
//       />
//     </Field>
//   );
// }

// function SelectInput({ label, value, onChange, children, disabled = false, error = "" }) {
//   return (
//     <Field label={label} error={error}>
//       <select
//         value={value}
//         onChange={onChange}
//         disabled={disabled}
//         className={`${inputClass} appearance-auto cursor-pointer ${
//           error ? errorClass : ""
//         }`}
//       >
//         {children}
//       </select>
//     </Field>
//   );
// }

// function SwitchInput({ label, checked, onChange, disabled = false }) {
//   return (
//     <div className={`flex h-14 items-center rounded-md border border-surface-200 bg-white px-3.5 ${disabled ? 'bg-gray-100 opacity-90' : ''}`}>
//       <label className={`flex items-center gap-3 text-[15px] text-surface-800 ${disabled ? 'cursor-not-allowed' : 'cursor-pointer'}`}>
//         <input
//           type="checkbox"
//           checked={checked}
//           onChange={onChange}
//           disabled={disabled}
//           className="h-5 w-5 cursor-pointer rounded border-surface-300 accent-primary-600 disabled:cursor-not-allowed"
//         />
//         <span>{label}</span>
//       </label>
//     </div>
//   );
// }

// function CurrencyInput({
//   label,
//   value,
//   onChange,
//   disabled = false,
//   error = "",
// }) {
//   return (
//     <Field label={label} error={error}>
//       <input
//         type="text"
//         inputMode="decimal"
//         value={value ?? ""}
//         disabled={disabled}
//         onChange={(event) => {
//           const maskedValue = maskCurrencyInput(event.target.value);
//           onChange({
//             target: {
//               type: "text",
//               value: maskedValue,
//             },
//           });
//         }}
//         className={`${inputClass} ${error ? errorClass : ""}`}
//       />
//     </Field>
//   );
// }

// export default function AddPayrollComponentDialog({
//   open,
//   onClose,
//   onSave,
//   loading = false,
//   mode = "add", // "add" | "edit" | "view"
//   component = null,
//   existingComponents = [],
// }) {
//   const [form, setForm] = useState(initialForm);
//   const [errors, setErrors] = useState({});

//   const isView = mode === "view";
//   const isEdit = mode === "edit";

//   useEffect(() => {
//     if (!open) return;

//     if ((isEdit || isView) && component) {
//       // Map entity model values (e.g., Earning -> E, Fixed -> F)
//       const mappedType =
//         component.type === "Earning" || component.type === "E"
//           ? "E"
//           : component.type === "Deduction" || component.type === "D"
//           ? "D"
//           : component.type === "Contribution" || component.type === "C"
//           ? "C"
//           : component.type || "E";

//       const mappedCalc =
//         component.calcMethod === "Fixed" || component.calcMethod === "F"
//           ? "F"
//           : component.calcMethod === "Daily-Based" || component.calcMethod === "Percentage" || component.calcMethod === "P"
//           ? "P"
//           : component.calcMethod || "F";

//       setForm({
//         id: component.id,
//         code: component.code || "",
//         name: component.name || "",
//         type: mappedType,
//         paymentType: component.paymentType || "M",
//         defaultAmount: maskCurrencyInput(component.defaultAmount || 0),
//         defaultPercentage: component.defaultPercentage ?? 0,
//         taxable: Boolean(component.taxable),
//         earningCategory: component.rawEarningCategory ?? (
//           component.earningCategory === "Fixed" ? "F" 
//           : component.earningCategory === "Variable" ? "V" 
//           : component.earningCategory || ""
//         ),
//         isEpf: Boolean(component.epf ?? component.isEpf),
//         isEtf: Boolean(component.etf ?? component.isEtf),
//         isOT: Boolean(component.otPayable ?? component.isOT),
//         isPayee: Boolean(component.isPayee),
//         isNoPay: Boolean(component.isNoPay),
//         calculationMethod: mappedCalc,
//         remarks: component.remarks || "",
//       });
//       setErrors({});
//     } else {
//       // In ADD mode, calculate the initial generated code
//       const defaultCat = "F";
//       const defaultType = "E";
//       const generatedCode = getNextComponentcode(existingComponents, defaultCat, defaultType);

//       setForm({
//         ...initialForm,
//         code: generatedCode,
//         earningCategory: defaultCat,
//         type: defaultType
//       });
//       setErrors({});
//     }
//   }, [open, mode, component, isEdit, isView]);

//   const handleChange = (field) => (e) => {
//     if (isView) return;

//     const value =
//       e.target.type === "checkbox"
//         ? e.target.checked
//         : e.target.value;

//     setForm((prev) => {
//       let updated = { ...prev, [field]: value };

//       // Auto generate code in ADD mode when Category or Type changes
//       if (!isEdit && (field === "earningCategory" || field === "type")) {
//         const cat = field === "earningCategory" ? value : prev.earningCategory;
//         const typ = field === "type" ? value : prev.type;
//         updated.code = getNextComponentcode(existingComponents, cat, typ);
//       }

//       if (field === "calculationMethod") {
//         updated.defaultAmount = value === "F" ? prev.defaultAmount : 0;
//         updated.defaultPercentage = value === "P" ? prev.defaultPercentage : 0;
//       }

//       return updated;
//     });

//     setErrors((prev) => ({
//       ...prev,
//       [field]: "",
//     }));
//   };

//   const validate = () => {
//     const newErrors = {};

//     if (!form.code.trim()) {
//       newErrors.code = "Component code is required.";
//     } else if (form.code.trim().length > 5) {
//       newErrors.code = "Component code cannot be longer than 5 characters.";
//     }

//     if (!form.name.trim()) {
//       newErrors.name = "Component name is required.";
//     }

//     if (form.calculationMethod === "F" && parseCurrency(form.defaultAmount) < 0) {
//       newErrors.defaultAmount = "Default amount cannot be negative.";
//     }

//     if (form.calculationMethod === "P") {
//       if (Number(form.defaultPercentage) <= 0) {
//         newErrors.defaultPercentage = "Default percentage cannot be 0 or negative.";
//       } else if (Number(form.defaultPercentage) > 100) {
//         newErrors.defaultPercentage = "Default percentage cannot be more than 100.";
//       }
//     }

//     setErrors(newErrors);
//     return Object.keys(newErrors).length === 0;
//   };

//   const handleSave = () => {
//     if (isView || !validate()) {
//       return;
//     }

//     onSave({
//       ...(isEdit && { id: form.id || component?.id }),
//       code: form.code,
//       name: form.name,
//       type: form.type,
//       paymentType: form.paymentType,
//       earningCategory: form.earningCategory || "",
//       calculationMethod: form.calculationMethod,
//       taxable: form.taxable,
//       isEpf: form.isEpf,
//       isEtf: form.isEtf,
//       isOT: form.isOT,
//       isNoPay: form.isNoPay,
//       remarks: form.remarks,
//       defaultAmount: form.calculationMethod === "F" ? parseCurrency(form.defaultAmount) : null,
//       defaultPercentage: form.calculationMethod === "P" ? Number(form.defaultPercentage || 0) : null,
//     });
//   };

//   const getTitle = () => {
//     if (isView) return "View Payroll Component";
//     if (isEdit) return "Edit Payroll Component";
//     return "New Payroll Component";
//   };

//   return (
//     <Dialog
//       open={open}
//       onClose={!loading ? onClose : undefined}
//       maxWidth="md"
//       fullWidth
//     >
//       <DialogTitle className="!px-6 !pt-5 !pb-3">
//         <span className="text-[21px] font-medium text-surface-900">
//           {getTitle()}
//         </span>
//       </DialogTitle>

//       <DialogContent className="!px-6 !py-5">
//         <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">

//           {/* Component Code */}
//           <TextInput
//             label="Component Code"
//             value={form.code}
//             disabled={isView || isEdit || true}
//             onChange={handleChange("code")}
//             error={errors.code}
//           />

//           {/* Component Name */}
//           <TextInput
//             label="Component Name"
//             value={form.name}
//             disabled={isView}
//             error={errors.name}
//             onChange={handleChange("name")}
//           />

//           {/* Earning Category */}
//           <SelectInput
//             label="Earning Category"
//             value={form.earningCategory}
//             disabled={isView}
//             onChange={handleChange("earningCategory")}
//           >
//             {earningCategories.map((item) => (
//               <option key={item.value} value={item.value}>
//                 {item.label}
//               </option>
//             ))}
//           </SelectInput>

//           {/* Component Type */}
//           <SelectInput
//             label="Component Type"
//             value={form.type}
//             disabled={isView}
//             onChange={handleChange("type")}
//           >
//             {componentTypes.map((item) => (
//               <option key={item.value} value={item.value}>
//                 {item.label}
//               </option>
//             ))}
//           </SelectInput>

//           {/* Payment Type */}
//           <SelectInput
//             label="Payment Type"
//             value={form.paymentType}
//             disabled={isView}
//             onChange={handleChange("paymentType")}
//           >
//             {paymentTypes.map((item) => (
//               <option key={item.value} value={item.value}>
//                 {item.label}
//               </option>
//             ))}
//           </SelectInput>

//           {/* Calculation Method */}
//           <SelectInput
//             label="Calculation Method"
//             value={form.calculationMethod}
//             disabled={isView}
//             onChange={handleChange("calculationMethod")}
//           >
//             {calculationMethods.map((item) => (
//               <option key={item.value} value={item.value}>
//                 {item.label}
//               </option>
//             ))}
//           </SelectInput>

//           {/* Default Amount */}
//           {form.calculationMethod === "F" && (
//             <CurrencyInput
//               label="Default Amount"
//               value={form.defaultAmount}
//               disabled={isView}
//               error={errors.defaultAmount}
//               onChange={handleChange("defaultAmount")}
//             />
//           )}

//           {/* Default Percentage */}
//           {form.calculationMethod === "P" && (
//             <TextInput
//               label="Default Percentage"
//               type="number"
//               min="0"
//               step="0.01"
//               value={form.defaultPercentage ?? ""}
//               disabled={isView}
//               error={errors.defaultPercentage}
//               onChange={handleChange("defaultPercentage")}
//             />
//           )}

//           {/* Remarks */}
//           <TextInput
//             label="Remarks"
//             value={form.remarks}
//             disabled={isView}
//             error={errors.remarks}
//             onChange={handleChange("remarks")}
//           />

//           {/* Taxable, EPF, and Payee Checkboxes */}
//           <div className="grid grid-cols-1 gap-3 sm:col-span-2 sm:grid-cols-5">
//             <SwitchInput
//               label="Payee"
//               checked={form.taxable}
//               disabled={isView}
//               onChange={handleChange("taxable")}
//             />

//             <SwitchInput
//               label="EPF"
//               checked={form.isEpf}
//               disabled={isView}
//               onChange={handleChange("isEpf")}
//             />

//             <SwitchInput
//               label="ETF"
//               checked={form.isEtf}
//               disabled={isView}
//               onChange={handleChange("isEtf")}
//             />

//             <SwitchInput
//               label="OT"
//               checked={form.isOT}
//               disabled={isView}
//               onChange={handleChange("isOT")}
//             />

//             <SwitchInput
//               label="No Pay"
//               checked={form.isNoPay}
//               disabled={isView}
//               onChange={handleChange("isNoPay")}
//             />
//           </div>

//         </div>
//       </DialogContent>

//       <DialogActions className="!px-6 !py-3">
//         <Button
//           onClick={onClose}
//           disabled={loading}
//           className="!text-primary-600"
//         >
//           {isView ? "CLOSE" : "CANCEL"}
//         </Button>

//         {!isView && (
//           <Button
//             variant="contained"
//             onClick={handleSave}
//             disabled={loading}
//             className="!bg-primary-600 hover:!bg-primary-700"
//           >
//             {loading ? "SAVING..." : isEdit ? "UPDATE" : "SAVE"}
//           </Button>
//         )}
//       </DialogActions>
//     </Dialog>
//   );
// }

import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
} from "@mui/material";
import { useEffect, useState } from "react";

const initialForm = {
  code: "",
  name: "",
  salarySlipDescription: "",
  description: "",
  accountNo: "",
  earningCategory: "F",
  type: "E",
  calculationMethod: "F",
  defaultAmount: 0,
  defaultPercentage: 0,
  remarks: "",

  // Checkboxes
  taxable: true,
  isEpf: false,
  isEtf: false,
  isOT: false,
  isNoPay: false,
  isBatch: false,
};

const earningCategories = [
  { value: "", label: "None" },
  { value: "F", label: "Fixed" },
  { value: "V", label: "Variable" },
];

const componentTypes = [
  { value: "E", label: "Allowance" },
  { value: "D", label: "Deduction" },
  { value: "C", label: "Contribution" },
];

const calculationMethods = [
  { value: "F", label: "Fixed" },
  { value: "P", label: "Daily-Based" },
];

const RULES = [
  { id: "taxable", label: "Payee (Taxable)" },
  { id: "isEpf", label: "EPF" },
  { id: "isEtf", label: "ETF" },
  { id: "isOT", label: "OT" },
  { id: "isNoPay", label: "No Pay" },
  { id: "isBatch", label: "Enable for Batch" },
];

const inputClass = `
  w-full h-10
  rounded-md
  border border-gray-300
  bg-white
  px-3
  text-[14px] text-gray-800
  outline-none
  transition-all
  placeholder:text-gray-400
  focus:border-primary-500 focus:ring-1 focus:ring-primary-500
  disabled:bg-gray-100 disabled:text-gray-500 disabled:cursor-not-allowed
`;

const errorClass = '!border-red-400 focus:!border-red-500 focus:!ring-red-200';

const formatInitialCurrency = (value) => {
  if (value === null || value === undefined || value === "") return "0.00";
  const num = Number(value);
  if (isNaN(num)) return "0.00";
  return num.toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

const maskCurrencyInput = (rawValue) => {
  const digits = String(rawValue ?? "").replace(/\D/g, "");
  if (!digits) return "";
  const padded = digits.padStart(3, "0");
  const cents = padded.slice(-2);
  const wholeDigits = padded.slice(0, -2).replace(/^0+(?=\d)/, "");
  const whole = Number(wholeDigits || "0").toLocaleString("en-US");
  return `${whole}.${cents}`;
};

const parseCurrency = (value) => {
  if (value === "" || value === null || value === undefined) return 0;
  const n = Number(String(value).replace(/,/g, ""));
  return Number.isNaN(n) ? 0 : n;
};

const getComponentPrefix = (earningCategory = "F", type = "E") => {
  if (earningCategory === "") {
    return "OI"
  }

  const catPrefix = earningCategory === "V" ? "V" : earningCategory === "F" ? "F" : "";
  const typeMap = { E: "A", D: "D", C: "C" };
  return `${catPrefix}${typeMap[type] || "A"}`;
};

const getNextComponentcode = (existingComponents = [], earningCategory = "F", type = "E") => {
  const prefix = getComponentPrefix(earningCategory, type);
  const regex = new RegExp(`^${prefix}(\\d+)$`, "i");

  let maxNum = 0;
  existingComponents.forEach((c) => {
    const code = String(c.code || "").trim();
    const match = code.match(regex);
    if (match) {
      const num = parseInt(match[1], 10);
      if (!isNaN(num) && num > maxNum) maxNum = num;
    }
  });

  return `${prefix}${String(maxNum + 1).padStart(3, "0")}`;
};

function FormField({ label, error = "", children }) {
  return (
    <div className="flex flex-col gap-1">
      <label className="text-[13px] font-medium text-gray-700">{label}</label>
      {children}
      {error && <span className="text-[11px] text-red-600">{error}</span>}
    </div>
  );
}

export default function AddPayrollComponentDialog({
  open,
  onClose,
  onSave,
  loading = false,
  mode = "add",
  component = null,
  existingComponents = [],
}) {
  const [form, setForm] = useState(initialForm);
  const [errors, setErrors] = useState({});

  const isView = mode === "view";
  const isEdit = mode === "edit";

  useEffect(() => {
    if (!open) return;

    if ((isEdit || isView) && component) {
      const mappedType =
        component.type === "Earning" || component.type === "E" ? "E"
        : component.type === "Deduction" || component.type === "D" ? "D"
        : component.type === "Contribution" || component.type === "C" ? "C"
        : component.type || "E";

      const mappedCalc =
        component.calcMethod === "Fixed" || component.calcMethod === "F" ? "F"
        : component.calcMethod === "Daily-Based" || component.calcMethod === "Percentage" || component.calcMethod === "P" ? "P"
        : component.calcMethod || "F";

      const rawCat = component.rawEarningCategory ?? component.earningCategory ?? "";
      const mappedCat =
        rawCat === "Fixed" || rawCat === "F" ? "F"
        : rawCat === "Variable" || rawCat === "V" ? "V"
        : "";

      setForm({
        id: component.id,
        code: component.code || "",
        name: component.name || "",
        salarySlipDescription: component.salarySlipDescription || "",
        description: component.description || "",
        accountNo: component.accountNo || "",
        type: mappedType,
        defaultAmount: formatInitialCurrency(component.defaultAmount || 0),
        defaultPercentage: component.defaultPercentage ?? 0,
        taxable: Boolean(component.taxable),
        earningCategory: mappedCat,
        isEpf: Boolean(component.epf ?? component.isEpf),
        isEtf: Boolean(component.etf ?? component.isEtf),
        isOT: Boolean(component.otPayable ?? component.isOT),
        isNoPay: Boolean(component.isNoPay),
        isBatch: Boolean(component.isBatch),
        calculationMethod: mappedCalc,
        remarks: component.remarks || "",
      });
      setErrors({});
    } else {
      const defaultCat = "F";
      const defaultType = "E";
      setForm({
        ...initialForm,
        code: getNextComponentcode(existingComponents, defaultCat, defaultType),
        earningCategory: defaultCat,
        type: defaultType,
      });
      setErrors({});
    }
  }, [open, mode, component, isEdit, isView]);

  const handleChange = (field) => (e) => {
    if (isView) return;

    let value = e.target.type === "checkbox" ? e.target.checked : e.target.value;

    if (field === "accountNo") {
      value = value.replace(/\D/g, "");
    }

    setForm((prev) => {
      let updated = { ...prev, [field]: value };

      if (!isEdit && (field === "earningCategory" || field === "type")) {
        const cat = field === "earningCategory" ? value : prev.earningCategory;
        const typ = field === "type" ? value : prev.type;
        updated.code = getNextComponentcode(existingComponents, cat, typ);
      }

      if (field === "calculationMethod") {
        updated.defaultAmount = value === "F" ? prev.defaultAmount : 0;
        updated.defaultPercentage = value === "P" ? prev.defaultPercentage : 0;
      }

      return updated;
    });

    setErrors((prev) => ({ ...prev, [field]: "" }));
  };

  const validate = () => {
    const newErrors = {};
    if (!form.code.trim()) newErrors.code = "Code is required.";
    if (!form.name.trim()) newErrors.name = "Component name is required.";
    if (form.calculationMethod === "F" && parseCurrency(form.defaultAmount) < 0) {
      newErrors.defaultAmount = "Default amount cannot be negative.";
    }
    if (form.calculationMethod === "P") {
      if (Number(form.defaultPercentage) <= 0 || Number(form.defaultPercentage) > 100) {
        newErrors.defaultPercentage = "Percentage must be between 0.01 and 100.";
      }
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSave = () => {
    if (isView || !validate()) return;

    onSave({
      ...(isEdit && { id: form.id || component?.id }),
      code: form.code,
      name: form.name,
      salarySlipDescription: form.salarySlipDescription,
      description: form.description,
      accountNo: form.accountNo,
      type: form.type,
      paymentType: "M", // Hardcoded Monthly
      earningCategory: form.earningCategory || "",
      calculationMethod: form.calculationMethod,
      taxable: form.taxable,
      isEpf: form.isEpf,
      isEtf: form.isEtf,
      isOT: form.isOT,
      isNoPay: form.isNoPay,
      isBatch: form.isBatch ? 1 : 0,
      remarks: form.remarks,
      defaultAmount: form.calculationMethod === "F" ? parseCurrency(form.defaultAmount) : null,
      defaultPercentage: form.calculationMethod === "P" ? Number(form.defaultPercentage || 0) : null,
    });
  };

  return (
    <Dialog open={open} onClose={!loading ? onClose : undefined} maxWidth="md" fullWidth>
      <DialogTitle className="!px-6 !pt-5 !pb-2">
        <span className="text-[18px] font-semibold text-gray-900">
          {isView ? "View Payroll Component" : isEdit ? "Edit Payroll Component" : "New Payroll Component"}
        </span>
      </DialogTitle>

      <DialogContent className="!px-6 !py-4 space-y-4">
        {/* Row 1 */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
          <FormField label="Component Code" error={errors.code}>
            <input
              type="text"
              value={form.code}
              disabled
              className={inputClass}
            />
          </FormField>

          <FormField label="Component Name" error={errors.name}>
            <input
              type="text"
              value={form.name}
              disabled={isView}
              onChange={handleChange("name")}
              className={`${inputClass} ${errors.name ? errorClass : ""}`}
            />
          </FormField>

          <FormField label="Description">
            <input
              type="text"
              value={form.description}
              disabled={isView}
              onChange={handleChange("description")}
              className={inputClass}
            />
          </FormField>
        </div>

        {/* Row 2 */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
          <FormField label="Salary Slip Description">
            <input
              type="text"
              value={form.salarySlipDescription}
              disabled={isView}
              onChange={handleChange("salarySlipDescription")}
              className={inputClass}
            />
          </FormField>

          <FormField label="Earning Category">
            <select
              value={form.earningCategory}
              disabled={isView}
              onChange={handleChange("earningCategory")}
              className={inputClass}
            >
              {earningCategories.map((item) => (
                <option key={item.value} value={item.value}>{item.label}</option>
              ))}
            </select>
          </FormField>

          <FormField label="Component Type">
            <select
              value={form.type}
              disabled={isView}
              onChange={handleChange("type")}
              className={inputClass}
            >
              {componentTypes.map((item) => (
                <option key={item.value} value={item.value}>{item.label}</option>
              ))}
            </select>
          </FormField>
        </div>

        {/* Row 3 */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
          <FormField label="Account Number">
            <input
              type="text"
              inputMode="numeric"
              value={form.accountNo}
              disabled={isView}
              onChange={handleChange("accountNo")}
              className={inputClass}
            />
          </FormField>

          <FormField label="Calculation Method">
            <select
              value={form.calculationMethod}
              disabled={isView}
              onChange={handleChange("calculationMethod")}
              className={inputClass}
            >
              {calculationMethods.map((item) => (
                <option key={item.value} value={item.value}>{item.label}</option>
              ))}
            </select>
          </FormField>

          {form.calculationMethod === "F" ? (
            <FormField label="Default Amount" error={errors.defaultAmount}>
              <input
                type="text"
                inputMode="decimal"
                value={form.defaultAmount}
                disabled={isView}
                onChange={(e) => {
                  const masked = maskCurrencyInput(e.target.value);
                  handleChange("defaultAmount")({ target: { type: "text", value: masked } });
                }}
                className={`${inputClass} ${errors.defaultAmount ? errorClass : ""}`}
              />
            </FormField>
          ) : (
            <FormField label="Default Percentage (%)" error={errors.defaultPercentage}>
              <input
                type="number"
                min="0"
                step="0.01"
                value={form.defaultPercentage ?? ""}
                disabled={isView}
                onChange={handleChange("defaultPercentage")}
                className={`${inputClass} ${errors.defaultPercentage ? errorClass : ""}`}
              />
            </FormField>
          )}
        </div>

        {/* Row 4: Description */}
        <FormField label="Remarks">
          <input
            type="text"
            value={form.remarks}
            disabled={isView}
            onChange={handleChange("remarks")}
            className={inputClass}
          />
        </FormField>

        {/* Row 5: Checkboxes */}
        <div className="pt-2">
          <span className="text-[12px] font-semibold text-gray-500 uppercase tracking-wide">
            Component Rules
          </span>
          <div className="mt-2.5 grid grid-cols-2 sm:grid-cols-3 gap-x-6 gap-y-3">
            {RULES.map((rule) => (
              <label
                key={rule.id}
                className={`inline-flex items-center gap-2 select-none ${
                  isView ? "cursor-default text-gray-500" : "cursor-pointer text-gray-700 hover:text-gray-900"
                }`}
              >
                <input
                  type="checkbox"
                  name={rule.id}
                  checked={Boolean(form[rule.id])}
                  disabled={isView}
                  onChange={handleChange(rule.id)}
                  className="h-4 w-4 rounded border-gray-300 text-primary-600 focus:ring-primary-500 disabled:cursor-not-allowed"
                />
                <span className="text-[13.5px] font-normal">{rule.label}</span>
              </label>
            ))}
          </div>
        </div>
      </DialogContent>

      <DialogActions className="!px-6 !py-3 border-t border-gray-100">
        <Button onClick={onClose} disabled={loading} className="!text-gray-600">
          {isView ? "Close" : "Cancel"}
        </Button>
        {!isView && (
          <Button
            variant="contained"
            onClick={handleSave}
            disabled={loading}
            className="!bg-primary-600 hover:!bg-primary-700"
          >
            {loading ? "Saving..." : isEdit ? "Update" : "Save"}
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
}